import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'
import type { RouteLocation, RouteLocationRaw } from 'vue-router'
import type { TColors } from '@/services/application/interfaces'
import { ref } from 'vue'

type tailwindColors = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 950

type IError = {
  id?: string
  title?: string
  translatedTitle?: string
  message?: string
  translatedMessage?: string
  /** named params interpolated in translatedTitle and translatedMessage */
  translatedParams?: Record<string, unknown>
  color: TColors
  duration?: number
  version?: number
  undoCallback?: () => void | Promise<void>
  /** Real router target so Ctrl/Cmd+click / middle-click work on the action. */
  undoTo?: RouteLocationRaw
  undoLabel?: string
}
type IState = {
  errors: Array<IError>
  previousApplicationRoute: RouteLocation | null
  drawer: {
    fixed: boolean
  }
  theme?: {
    colors: {
      hsl: {
        [tailwindColors: number | string]: string
      }
      hex: {
        [tailwindColors: number | string]: string
      }
    }
  }
}

export const useApplicationStore = defineStore('application', () => {

  const errors = ref([])

  const drawer = ref({
    fixed: typeof window !== 'undefined' ? window.innerWidth >= 1400 : true,
  })
  const theme = ref<TColors>()

  const previousApplicationRoute = ref<RouteLocation | null>(null)

  const removeError = (errorOrIndex: number | { id?: string }) => {
    if (typeof errorOrIndex === 'number') {
      errors.value.splice(errorOrIndex, 1)
      return
    }

    const index = errors.value.findIndex((currentError) => currentError.id === errorOrIndex.id)
    if (index !== -1)
      errors.value.splice(index, 1)
  }

  const pushError = ({ color = 'error', duration = 5000, version = 0, ...error }: IError) => {
    const id = `${new Date().getTime()}}`
    const foundExistingError = errors.value.findIndex(currentError => {
      return currentError.title === error.title && error.message === currentError.message
    })

    if(foundExistingError !== -1)
      return errors.value[foundExistingError].version = errors.value[foundExistingError].version + 1

    errors.value.push({
      ...error,
      id,
      color,
      duration,
      version,
    })
  }

  const resetErrors = () => {
    errors.value = []
  }

  return {
    errors,
    drawer,
    theme,
    previousApplicationRoute,
    pushError,
    removeError,
    resetErrors,
  }


},
  {
    persist: true,
  }
)
